import { useQuery } from '@tanstack/react-query';

import Api from '@app/services/api';

export const useGetCatalogQuery = (id: string) => {
  return useQuery({
    queryKey: ['getCatalog', id],
    queryFn: () => Api.products.getCatalog(id),
    enabled: !!id,
  });
};
